module.exports = __webpack_public_path__ + "dd65501f3f15f81bb96e6ed0e5ab654f.jpg";